import { ChartConfig, ChartContainer } from "design-system/molecules/Chart"
import { cn } from "design-system/utils"
import { Cell, Label, Pie, PieChart } from "recharts"

const mapNegativeNPS = (nps: number) => {
  return (nps + 100) * 0.5
}

const mapPositiveNPS = (nps: number) => {
  return 50 + nps * 0.5
}

const chartConfig = {} satisfies ChartConfig

type Props = {
  nps: number | undefined
  isPending: boolean
}

export function NetPromoterScore({ nps, isPending }: Props) {
  if (isPending) {
    return
  }

  const noData = !nps
  const chartNps = nps ? Math.min(Math.max(nps, -100), 100) : 0

  const gaugeData = [
    { value: chartNps < 0 ? mapNegativeNPS(chartNps) : 0 }, // Negative
    { value: chartNps >= 0 && chartNps < 40 ? mapPositiveNPS(chartNps) : 0 }, // Neutral
    { value: chartNps >= 40 ? mapPositiveNPS(chartNps) : 0 }, // Positive
    { value: chartNps < 0 ? 100 - mapNegativeNPS(chartNps) : 100 - mapPositiveNPS(chartNps) }, // Background
  ]

  return (
    <ChartContainer
      config={chartConfig}
      className={cn(
        "mx-auto aspect-square h-[80px]",
        noData && "pointer-events-none grayscale opacity-25 dark:opacity-5",
      )}
    >
      <PieChart>
        <Pie
          data={gaugeData}
          dataKey="value"
          startAngle={210}
          endAngle={-30}
          innerRadius={27}
          outerRadius={35}
          cornerRadius={0}
        >
          <Cell fill="var(--negative)" /> {/* Left active (negative) */}
          <Cell fill="var(--neutral)" /> {/* Right active (positive) */}
          <Cell fill="var(--positive)" /> {/* Right active (positive) */}
          <Cell fill="var(--muted)" /> {/* Right background */}
          <Label
            content={({ viewBox }) => {
              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                return (
                  <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                    <tspan
                      x={viewBox.cx}
                      y={viewBox.cy}
                      className="fill-foreground text-2xl font-normal font-mono"
                    >
                      {noData ? "-" : nps}
                    </tspan>
                  </text>
                )
              }
            }}
          />
        </Pie>
      </PieChart>
    </ChartContainer>
  )
}
